import { render, staticRenderFns } from "./jinxian.vue?vue&type=template&id=a23c5f7c&scoped=true&"
import script from "./jinxian.vue?vue&type=script&lang=js&"
export * from "./jinxian.vue?vue&type=script&lang=js&"
import style0 from "./jinxian.vue?vue&type=style&index=0&id=a23c5f7c&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a23c5f7c",
  null
  
)

export default component.exports